app.factory('medicalPostModel', ['$rootScope', 'baseModel', 'medicalPostService', '$q',
    function($rootScope, baseModel, medicalPostService, $q) {

        function MedicalPostModel() {

            this.getMedicalChamberList = function() {
                return medicalPostService.getMedicalChamberList().then(
                    function (dataPage) {
                        return dataPage;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                );
            };

        }

        return new MedicalPostModel();
    }
]);
